import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChalkboardTeacher, faTools, faCalendar, faClock, faUser, faMoneyBill, faCalendarCheck } from "@fortawesome/free-solid-svg-icons";

const SheEarnsTrainingWorkshop = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("trainings");
  const [selectedItem, setSelectedItem] = useState(null);

  const trainings = [
    {
      id: 1,
      title: "Digital Marketing Essentials",
      mode: "Online",
      date: "25 Oct 2025",
      time: "6:00 PM - 8:00 PM",
      organizer: "SheEarns Academy",
      fee: "₹499",
      lastDate: "24 Oct 2025",
      description:
        "A comprehensive online session to master SEO, social media marketing, and personal branding for freelancers and entrepreneurs.",
    },
    {
      id: 2,
      title: "Financial Literacy for Women",
      mode: "Online",
      date: "28 Oct 2025",
      time: "5:00 PM - 7:00 PM",
      organizer: "WomenRise Foundation",
      fee: "Free",
      lastDate: "27 Oct 2025",
      description:
        "Empowering women with practical financial knowledge on budgeting, savings, investments, and business credit.",
    },
    {
      id: 3,
      title: "Soft Skills & Communication",
      mode: "Online",
      date: "30 Oct 2025",
      time: "4:00 PM - 6:00 PM",
      organizer: "SkillBoost Hub",
      fee: "₹299",
      lastDate: "29 Oct 2025",
      description:
        "Interactive workshop to enhance communication, leadership, and collaboration skills in a digital workplace.",
    },
  ];

  const workshops = [
    {
      id: 1,
      title: "Handmade Jewelry Design",
      mode: "Online",
      date: "26 Oct 2025",
      time: "3:00 PM - 5:00 PM",
      organizer: "Creative Women Studio",
      fee: "₹399",
      lastDate: "25 Oct 2025",
      description:
        "Learn to create beautiful handmade jewelry using affordable materials — perfect for small home-based businesses.",
    },
    {
      id: 2,
      title: "Candle Crafting Workshop",
      mode: "Online",
      date: "29 Oct 2025",
      time: "2:00 PM - 4:00 PM",
      organizer: "SheArt Collective",
      fee: "₹299",
      lastDate: "28 Oct 2025",
      description:
        "Step-by-step live session to make designer candles, packaging tips, and online selling techniques.",
    },
    {
      id: 3,
      title: "Organic Beauty Products",
      mode: "Online",
      date: "31 Oct 2025",
      time: "5:30 PM - 7:30 PM",
      organizer: "EcoGlow Workshop",
      fee: "₹499",
      lastDate: "30 Oct 2025",
      description:
        "DIY skincare & haircare products using natural ingredients — learn formulation and marketing strategies.",
    },
  ];

  const dataToShow = activeTab === "trainings" ? trainings : workshops;

  return (
    <div className="min-h-screen bg-gray-950 text-pink-100 flex flex-col items-center p-4">
      <h2 className="text-2xl font-semibold mb-4 text-pink-300">
        SheEarns Training & Workshops
      </h2>

      {/* Tabs */}
      <div className="grid grid-cols-2 w-full sm:w-1/2 gap-2 mb-6">
        <button
          onClick={() => {
            setSelectedItem(null);
            setActiveTab("trainings");
          }}
          className={`py-2 rounded-md font-semibold flex items-center justify-center gap-2 transition ${
            activeTab === "trainings"
              ? "bg-pink-600 text-white"
              : "bg-gray-800 text-pink-300 hover:bg-gray-700"
          }`}
        >
          <FontAwesomeIcon icon={faChalkboardTeacher} /> Trainings
        </button>

        <button
          onClick={() => {
            setSelectedItem(null);
            setActiveTab("workshops");
          }}
          className={`py-2 rounded-md font-semibold flex items-center justify-center gap-2 transition ${
            activeTab === "workshops"
              ? "bg-pink-600 text-white"
              : "bg-gray-800 text-pink-300 hover:bg-gray-700"
          }`}
        >
          <FontAwesomeIcon icon={faTools} /> Workshops
        </button>
      </div>

      {/* List or Details */}
      <div className="w-full sm:w-3/4 lg:w-1/2">
        {!selectedItem ? (
          <div className="space-y-3">
            {dataToShow.map((item) => (
              <div
                key={item.id}
                onClick={() => setSelectedItem(item)}
                className="bg-gray-900 border border-gray-700 hover:border-pink-500 transition rounded-lg p-4 cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-pink-300 mb-2">
                  {item.title}
                </h3>
                <div className="text-sm space-y-1">
                  <p>
                    <FontAwesomeIcon icon={faClock} className="mr-2 text-pink-400" />
                    Mode: {item.mode}
                  </p>
                  <p>
                    <FontAwesomeIcon icon={faCalendar} className="mr-2 text-pink-400" />
                    Date: {item.date}
                  </p>
                  <p>
                    <FontAwesomeIcon icon={faUser} className="mr-2 text-pink-400" />
                    Organizer: {item.organizer}
                  </p>
                  <p>
                    <FontAwesomeIcon icon={faMoneyBill} className="mr-2 text-pink-400" />
                    Entry Fee: {item.fee}
                  </p>
                  <p>
                    <FontAwesomeIcon icon={faCalendarCheck} className="mr-2 text-pink-400" />
                    Last Date: {item.lastDate}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-gray-900 border border-pink-600 rounded-lg p-4 text-sm">
            <h3 className="text-lg font-semibold text-pink-300 mb-2">
              {selectedItem.title}
            </h3>
            <div className="space-y-1 mb-3">
              <p>
                <FontAwesomeIcon icon={faClock} className="mr-2 text-pink-400" />
                Mode: {selectedItem.mode}
              </p>
              <p>
                <FontAwesomeIcon icon={faCalendar} className="mr-2 text-pink-400" />
                Date: {selectedItem.date}
              </p>
              <p>
                <FontAwesomeIcon icon={faUser} className="mr-2 text-pink-400" />
                Organizer: {selectedItem.organizer}
              </p>
              <p>
                <FontAwesomeIcon icon={faMoneyBill} className="mr-2 text-pink-400" />
                Entry Fee: {selectedItem.fee}
              </p>
              <p>
                <FontAwesomeIcon icon={faCalendarCheck} className="mr-2 text-pink-400" />
                Last Date: {selectedItem.lastDate}
              </p>
            </div>
            <p className="text-gray-300 mb-4">{selectedItem.description}</p>

            <div className="flex flex-col sm:flex-row justify-center gap-3">
              <button
                onClick={() => setSelectedItem(null)}
                className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-md font-medium transition"
              >
                Close
              </button>
              <button
                onClick={() => navigate("/enroll/workshop")}
                className="bg-pink-600 hover:bg-pink-700 text-white px-4 py-2 rounded-md font-medium transition"
              >
                Enroll
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SheEarnsTrainingWorkshop;
